import Container from "../../../components/Container";
import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import { db } from "../../../services/firebase";
import { Table, Select, Modal, notification } from "antd";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { EyeOutlined, EditOutlined, DeleteOutlined, UserOutlined, PlusOutlined } from "@ant-design/icons";

function Users() {
  const [clients, setClients] = useState([]);
  const [users, setUsers] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const { Option } = Select;

  const handleDelete = async (id, nomeUsuario) => {
    Modal.confirm({
      title: "Deseja excluir este usuário?",
      content: `O usuário "${nomeUsuario}" será removido permanentemente.`,
      okText: "Sim, excluir",
      okType: "danger",
      cancelText: "Cancelar",
      onOk: async () => {
        try {
          await deleteDoc(doc(db, "usuarios", id));
          notification.success({
            message: "Usuário excluído!",
            description: "O usuário foi removido com sucesso.",
            placement: "topRight",
          });
          fetchUsersFirebase();
        } catch (error) {
          console.error("Erro ao excluir usuário:", error);
          notification.error({
            message: "Erro ao excluir",
            description: "Não foi possível excluir o usuário.",
            placement: "topRight",
          });
        }
      },
    });
  };

  const columns = [
    {
      title: "Nome",
      dataIndex: "nomeUsuario",
      key: "nomeUsuario",
    },
    {
      title: "Login",
      dataIndex: "loginUsuario",
      key: "loginUsuario",
    },
    {
      title: "Empresa",
      dataIndex: "nomeEmpresa",
      key: "nomeEmpresa",
    },
    {
      title: "Unidade",
      dataIndex: "unidadeCliente",
      key: "unidadeCliente",
    },
    {
      title: "Ações",
      dataIndex: "id",
      key: "actions",
      width: 140,
      render: (id, record) => (
        <div className="actions-cell">
          <Link to={`/admin/usuario/${id}`} className="action-btn view">
            <EyeOutlined />
          </Link>
          <Link to={`/admin/cadastro-usuario/${id}`} className="action-btn edit">
            <EditOutlined />
          </Link>
          <button
            onClick={() => handleDelete(id, record.nomeUsuario)}
            className="action-btn delete"
          >
            <DeleteOutlined />
          </button>
        </div>
      ),
    },
  ];

  const fetchClientsFirebase = useCallback(async () => {
    const snapshot = await getDocs(collection(db, "clientes"));
    const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    return data;
  }, []);

  const fetchUsersFirebase = useCallback(async () => {
    try {
      const snapshot = await getDocs(collection(db, "usuarios"));
      const usuarios = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((usuario) => usuario.tipoUsuario === "cliente");
      const clientes = await fetchClientsFirebase();
      setClients(clientes);
      const data = usuarios.map((usuario) => {
        const client = clientes.find((c) => c.id === usuario.cliente_id);
        return {
          ...client,
          ...usuario,
        };
      });

      // Ordenar por data de criação (mais novos primeiro)
      const orderedData = data.sort((a, b) => {
        const dateA = a.dataCadastro?.toDate?.() || a.dataCadastro?.seconds ? new Date(a.dataCadastro.seconds * 1000) : new Date(0);
        const dateB = b.dataCadastro?.toDate?.() || b.dataCadastro?.seconds ? new Date(b.dataCadastro.seconds * 1000) : new Date(0);
        return dateB - dateA;
      });

      setFilteredUsers(orderedData);
      setUsers(orderedData);
    } catch (error) {
      console.error("Erro ao buscar usuário:", error);
    }
  }, [fetchClientsFirebase]);

  const getUnidades = useCallback((nomeEmpresa) => {
    const resultado = clients.find(
      (cliente) => cliente.nomeEmpresa === nomeEmpresa
    );
    if (resultado) {
      setUnidades(resultado.unidades);
    }
  }, [clients]);

  const filterUsers = useCallback((e) => {
    getUnidades(e.target.value);
    const search = e.target.value;
    const result = users.filter(
      (user) =>
        user.nomeEmpresa.toLowerCase().includes(search.toLowerCase()) ||
        user.unidadeCliente.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredUsers(result);
  }, [users, getUnidades]);

  useEffect(() => {
    fetchUsersFirebase();
  }, [fetchUsersFirebase]);

  return (
    <Container>
      <div className="user-list-container">
        <div className="list-card">
          <div className="list-header">
            <div className="list-header-left">
              <div className="list-icon">
                <UserOutlined />
              </div>
              <div>
                <h2 className="list-title">Usuários Cadastrados</h2>
                <p className="list-subtitle">{filteredUsers.length} usuários encontrados</p>
              </div>
            </div>
          </div>

          <div className="filters-bar">
            <Select
              placeholder="Selecione o Cliente"
              onChange={(value) => filterUsers({ target: { value } })}
              className="filter-select"
              allowClear
            >
              {clients.map((item) => (
                <Option key={item.id} value={item.nomeEmpresa}>
                  {item.nomeEmpresa}
                </Option>
              ))}
            </Select>

            <Select
              placeholder="Selecione a Unidade"
              onChange={(value) => filterUsers({ target: { value } })}
              className="filter-select"
              allowClear
            >
              {unidades.map((item, index) => (
                <Option key={index} value={item.unidade}>
                  {item.unidade}
                </Option>
              ))}
            </Select>
          </div>

          <Table
            dataSource={filteredUsers}
            columns={columns}
            rowKey="id"
            className="custom-table"
          />
        </div>

        <Link to="/admin/cadastro-usuario" className="fab-button" title="Novo Usuário">
          <PlusOutlined />
        </Link>
      </div>
    </Container>
  );
}

export default Users;
